import React from 'react';
import Tabs from 'components/utilities/tabs/Tabs';
import { useSelector } from 'react-redux';

// Import helrpes
import { articlesTabs } from './helpers/index';

const ArticlesTabs = () => {
	const { languages: contentTranslationLanguages } = useSelector(
		({ content_translations }) => content_translations.language_list
	);
	return <Tabs tabs={articlesTabs(contentTranslationLanguages)} />;
};

export default ArticlesTabs;
